import type { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { SettingsSectionContainer } from './section'

function SettingsGrid({ children, className, ...props }: ComponentProps<'div'>) {
  return (
    <SettingsSectionContainer
      data-slot="settings-grid"
      className={twMerge('grid w-full grid-cols-1 items-start gap-4 lg:grid-cols-2', className)}
      {...props}
    >
      {children}
    </SettingsSectionContainer>
  )
}

export { SettingsGrid }
